import styled from "styled-components";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { Colors, Spacing } from "@paclife/plds.tokens";
import { Icon } from "@paclife/plds.icon";

import Typography from "common/Typography/Typography";

const Wrapper = styled.div`
    margin-top: ${Spacing[8]};
`;

const Status = styled.div`
    display: flex;
    margin-bottom: ${Spacing[8]};
`;

const Text = styled(Typography)`
    font-style: italic;
    margin-right: ${Spacing[4]};
`;

const MFAStatus = ({ status }) => {
    const { t } = useTranslation("mfa");

    if (status === "VERIFIED" || status === "ACTIVE") {
        return (
            <Wrapper>
                <Status>
                    <Text ariant="caption" display="block">
                        {t("mfa:active")}
                    </Text>
                    <Icon
                        name="checkmarkFilled"
                        width={20}
                        color={Colors.green500}
                    />
                </Status>
            </Wrapper>
        );
    }    
    return null;
};

export default MFAStatus;

MFAStatus.propTypes = {
    status: PropTypes.oneOf(["ACTIVE", "PENDING_ACTIVATION", "VERFIED"])
};

MFAStatus.defaultProps = {
    status: undefined
};